import { render, staticRenderFns } from "./EditarEnvioProceso.vue?vue&type=template&id=1b155e78"
import script from "./EditarEnvioProceso.vue?vue&type=script&lang=js"
export * from "./EditarEnvioProceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports